<script>
  import { ReadingsStore, UnitsStore, UnitOptionsIDToName } from "../stores.js";

  function ArraySum(arr) {
    var result = 0,
      n = arr.length || 0; //may use >>> 0 to ensure length is Uint32
    while (n--) {
      result += +arr[n]; // unary operator to ensure ToNumber conversion
    }
    return result;
  }

  function GetAverageHeight(_arr) {
    let arr = _arr.filter(Boolean);
    let total = arr.length;
    let sum = ArraySum(arr);
    // console.log(`Array - ${arr}\nSum - ${sum}`);
    return sum / total;
  }

  let AverageHeight = 0;

  $: {
    AverageHeight = GetAverageHeight(
      $ReadingsStore.map(function(el) {
        return el.building_height;
      })
    );
  }

  import _copy from "./_copy.svelte";

  const copy = () => {
    const app = new _copy({
      target: document.getElementById("clipboard"),
      props: {
        name: `${AverageHeight} ${$UnitOptionsIDToName[$UnitsStore]}`
      }
    });
    app.$destroy();
  };
  // https://svelte.dev/repl/3194502389af4e22991f8bb0c61d65cf?version=3.16.5
</script>

<!-- クリップボードにコピーするためのテキストエリアを一時配置するための領域 -->
<div id="clipboard"></div>

<div class="overflow-x-auto ">
  <table class="table w-full">
    <thead>
      <tr>
        <th>S. No</th> 
        <th>Altitude</th> 
        <th>Distance</th> 
        <th>Angle</th> 
        <th>Building Height</th> 
      </tr>
    </thead> 
    <tbody>
      {#each $ReadingsStore as stat, idx}
        <tr>
          <th>{idx + 1}</th> 
          <td>{ stat['user_height'] || 0 } { $UnitsStore }</td> 
          <td>{ stat['object_distance'] || 0 } { $UnitsStore }</td> 
          <td>{ stat['angle_difference'] || 0 }°</td> 
          <td>{ stat['building_height'] || 0 } { $UnitsStore }</td> 
        </tr>
      {/each}
    <tfoot>
      <tr>
        <th>Average Height</th> 
        <th on:click={copy}><strong class="link-hover">{Number(AverageHeight || 0).toFixed(2)} {$UnitsStore || "Units"}</strong></th> 
        <th></th> 
        <th></th> 
        <th></th> 
      </tr>
    </tfoot>
  </table>
</div>